import { getApiUrl } from "./Settings";
import { removeToken, getToken } from "./Auth";
import refreshToken from "./RefreshToken";
import { toast } from "./Toasts";

let unauthedCallback = function() {};

let baseUrl;

export default async function request(uri, opt = {}) {
  async function doRequestInner() {
    const headers = new Headers();
    const token = opt.token ? opt.token : getToken();
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    if (token) {
      headers.set("Authorization", "Bearer " + token);
    }
    // Mark so the global fetch observer does not duplicate toasts for this request
    headers.set("X-Toast-Handled", "1");

    const options = {
      headers,
      mode: "cors",
      ...opt
    };
    if (!baseUrl) {
      baseUrl = await getApiUrl();
    }
    const result = await fetch(baseUrl + uri, options);
    let data;
    try {
      data = await result.json();
    } catch (e) {
      data = undefined;
    }

    if (result.status === 401 && data) {
      return expiredOrDenied(data, doRequestInner);
    }

    const method = (options.method || "GET").toUpperCase();
    const isMutation =
      method === "POST" ||
      method === "PUT" ||
      method === "DELETE" ||
      method === "PATCH";

    if (!result.ok) {
      const msg =
        (data && (data.error || data.message)) ||
        `${method} ${uri} failed (${result.status})`;
      if (result.status !== 401) {
        toast.error(msg);
      }
      return data !== undefined
        ? data
        : { error: true, status: result.status, message: msg };
    }

    if (isMutation) {
      const msg = (data && (data.message || data.status)) || "Endringer lagret";
      toast.success(msg);
    }

    return data;
  }

  return doRequestInner();
}

function expiredOrDenied(data, retry) {
  removeToken();

  if (!data.expired) {
    return onFail();
  }

  return refreshToken(data.location).then(retry, onFail);

  function onFail() {
    unauthedCallback(data);
    return data;
  }
}

export function set401Action(fn) {
  unauthedCallback = fn;
}
